
<template>
    <template v-if="showOptions || secundary(items).length">
        <div class="elementOptions dropdown" v-click-away="handleAway">
            <button type="button" class="button inline" :title="trans('Toon opties')" @click.prevent="toggleDropdown('options')">
                <Icon name="dots" />
            </button>
            <div class="dropdown-menu dropdown-menu-right" :class="{ 'show' : isDropdownOpen('options') }">
                <ul class="block-grid one-up">
                    <template v-if="showOptions">
                        <li>
                            <button type="button" class="button" @click.prevent="handleMarkRead">
                                <Icon name="email-open" />
                                <span class="title">{{ trans("Als gelezen markeren") }}</span>
                            </button>
                        </li>
                        <li>
                            <button type="button" class="button" @click.prevent="handleMarkUnread">
                                <Icon name="email" />
                                <span class="title">{{ trans("Als ongelezen markeren") }}</span>
                            </button>
                        </li>
                    </template>
                    <template v-if="secundary(items).length">
                        <li class="hr" v-if="showOptions"></li>
                        <li v-for="item in secundary(items)">
                            <button
                                type="button"
                                class="button"
                                :title="item.title"
                                :disabled="inboxStore.loading || inboxactionStore.triggered"
                                @click.prevent="handleClick(item)"
                            >
                                <Icon :name="iconName(item)" />
                                <span class="title">{{ item.title }}</span>
                            </button>
                        </li>

                        <template v-if="primary(items).length">
                            <li class="hr"></li>
                            <li v-for="item in primary(items)">
                                <button
                                    type="button"
                                    class="button"
                                    :title="item.title"
                                    :disabled="inboxStore.loading || inboxactionStore.triggered"
                                    @click.prevent="handleClick(item)"
                                >
                                    <Icon :name="iconName(item)" />
                                    <span class="title">{{ item.title }}</span>
                                </button>
                            </li>
                        </template>
                    </template>
                </ul>
            </div>
        </div>
    </template>
    <button v-if="showRestore"
            type="button"
            class="button inline"
            :title="trans('Herstel item')"
            :disabled="inboxStore.loading || inboxactionStore.triggered"
            @click.prevent="handleRestore"
    >
        <Icon name="restore" />
    </button>
    <button v-for="item in items"
            type="button"
            class="button inline"
            :title="item.title"
            :disabled="inboxStore.loading || inboxactionStore.triggered"
            @click.prevent="handleClick(item)"
    >
        <Icon :name="iconName(item)" />
    </button>
    <Teleport to="#topcontainer">
        <PopupHtml ref="popupLinkcardRef" :confirmHandler="handleLinkcardForm">
            <template v-slot:after_message>
                <form class="cs_form">
                    <Fields
                        :fields="linkcardFields"
                        :values="{}"
                    />
                </form>
            </template>
        </PopupHtml>
        <PopupConfirm ref="popupConfirmRef" />
    </Teleport>
</template>

<script>
import {defineComponent, onMounted, computed, inject, ref, watch, onUnmounted, reactive} from "vue";
import {useRouter, useRoute} from "vue-router";

// Config for API urls used in this vue template
import { inboxStore, getInbox, patchInbox, clearInboxCache, updateAllCount } from "store/inbox-store";
import { inboxactionStore, getInboxactions, postInboxeventaction, inboxactionMessageareaStore } from "store/inboxaction-store";
import { handleRead, handleUnread } from "helpers/_inbox-helpers";

import Fields from "components/fields";
import PopupConfirm from "components/popupConfirm";
import PopupHtml from "components/popupHtml";

import Icon from "components/icon";
import trans from "helpers/_translation";

export default defineComponent({
    name: "inbox-actions",
    components: {
        Icon,
        Fields,
        PopupConfirm,
        PopupHtml
    },
    props: {
        routeData: {
            type: Object,
            required: true
        },
        item: {
            type: Object,
            default: null
        }
    },
    setup(props) {

        const router = useRouter();
        const route = useRoute();
        const popupConfirmRef = ref();
        const popupLinkcardRef = ref();

        // WM specific, can be replaced with newer functions
        const clearNotifications = inject("clearNotifications");
        const addNotification = inject("addNotification");

        const routeData = computed(() => {
            return props.routeData;
        });

        const type = (item) => {
            return computed(() => {
                return item.extra.inboxeventaction?.[0]?.action_type ?? "add";
            }).value;
        };
        const allowed_types = [
            // "deletemessage",
            // "createcard"
        ];
        const items = computed(() => {
            return inboxactionStore.items.filter(item => {
                if (item.id == 5 && props.item) {
                    return false;
                }
                if (routeData.value.item_id || props.item) {
                    return true;
                }
                if (allowed_types.includes(type(item))) {
                    return true;
                }
                return false;
            });
        });
        const iconMap = {
            "createcard": "add",
            "linkcard": "link",
            "deletemessage": "delete",
            "replymessage": "send",
            "forwardmessage": "forward"
        };
        const iconName = (item) => {
            return computed(() => {
                if (item?.icon) {
                    return item.icon;
                }
                return iconMap[type(item)] ?? "add";
            }).value;
        };

        const deleteAction = computed(() => {
            return inboxactionStore.items.find((item) => item.extra.inboxeventaction.some(a => a.action_type === "deletemessage"));
        });

        const resolveItem = (target, id) => {
            return target.find(i => `${i.data.id}` === `${id}`);
        };
        const linkcardData = reactive({
            event: [],
            result: []
        });
        const handleClick = (action) => {
            return new Promise(async (finished) => {

                // Store curren list so in any case our data is set for checks
                const backupItems = inboxStore.current?.data ? [inboxStore.current] : JSON.parse(JSON.stringify(inboxStore.items));
                // Set loader
                inboxactionStore.triggered = true;
                inboxactionStore.pause_filters = true;

                // Loop through our ids and trigger events
                const patchPromises = [];
                let eventPromises = [];

                if (props.item) {
                    inboxStore.selected = [props.item.data.id];
                }

                if (!inboxStore.selected.length) {
                    // No items selected
                    addNotification(trans("Selecteer eerst een item") + "...", 3500);
                    inboxactionStore.triggered = false;
                    inboxactionStore.pause_filters = false;

                    return;
                }

                // Build our events
                let hasDelete = false;

                let finalEventTracker = {};

                inboxStore.selected.forEach(id => {
                    // Find the item
                    const item = resolveItem(backupItems, id);
                    if (!item) return console.error("Item not found in inboxStore.items", id);

                    let tmpEventactions = JSON.parse(JSON.stringify(action.extra.inboxeventaction));
                    if (tmpEventactions.some(a => a.action_type === "deletemessage")) {
                        hasDelete = true;
                        // Item should be set to state Delete first
                        // Means they move to "trash" first based on state Offline
                        if (!["Offline","Delete"].includes(item.data.state)) {
                            const tmpFunction = () => {
                                return new Promise(resolve => {
                                    patchInbox(id, {state: "Offline"}).then(result => {
                                        inboxStore.items = inboxStore.items.filter(i => `${i.data.id}` !== `${id}`);
                                        resolve(result);
                                    });
                                });
                            };
                            patchPromises.push(tmpFunction);

                            tmpEventactions = tmpEventactions.filter(a => a.action_type !== "deletemessage");
                        }
                    }

                    for (const eventaction of tmpEventactions) {
                        if (!(eventaction.action_type in finalEventTracker)) {
                            finalEventTracker[eventaction.action_type] = [];
                        }
                        finalEventTracker[eventaction.action_type].push(eventaction);

                        const tmpFunction = () => {
                            return new Promise(resolve => {
                                const extra_data = {};
                                if (eventaction.action_type === "linkcard") {
                                    const targetValue = linkcardData.values[`${eventaction.id}`];
                                    extra_data.workflowcard_id = targetValue;
                                    if (!targetValue) {
                                        return resolve();
                                    }
                                }
                                if (["forwardmessage","replymessage"].includes(eventaction.action_type)) {
                                    // Since they need user input and are triggered manually we skip them for now
                                    return resolve();
                                }
                                postInboxeventaction(eventaction.id, id, extra_data).then(result => {
                                    if (eventaction.action_type === "deletemessage") {
                                        // Remove the item from the list
                                        inboxStore.items = inboxStore.items.filter(i => `${i.data.id}` !== `${id}`);
                                    } else {
                                        // Update the item
                                        const index = inboxStore.items.findIndex(i => `${i.data.id}` === `${id}`);
                                        if (index !== -1) {
                                            inboxStore.items[index] = result;
                                        }
                                    }
                                    resolve(result);
                                });
                            });
                        };
                        eventPromises.push(tmpFunction);
                    }

                });

                let ok = true;
                if (Object.keys(finalEventTracker).some(key => ["deletemessage", "createcard"].includes(key))) {
                    // No items to delete
                    ok = await popupConfirmRef.value.show();
                }
                if (Object.keys(finalEventTracker).some(key => ["linkcard"].includes(key))) {
                    // No items to delete
                    linkcardData.event = finalEventTracker.linkcard;
                    ok = await popupLinkcardRef.value.show({
                        title: "Maak uw keuze",
                        message: "",
                        okButton: "Koppelen"
                    });
                }
                if (!ok) {
                    inboxactionStore.triggered = false;
                    inboxactionStore.pause_filters = false;
                    return finished();
                }
                Promise.all([...eventPromises, ...patchPromises].map(func => func())).then(result => {
                    inboxactionStore.triggered = false;
                    clearInboxCache(routeData.value);
                    getInbox(routeData.value, [], false).then(() => {
                        if (hasDelete) {
                            gotoOverview();
                        }
                        setTimeout(() => {
                            inboxactionStore.pause_filters = false;
                        }, 500);
                    });
                    if (Object.keys(finalEventTracker).some(a => ["forwardmessage","replymessage"].includes(a))) {
                        const targetEvent = Object.keys(finalEventTracker).find(a => ["forwardmessage","replymessage"].includes(a));
                        if (props.item){
                            router.push(`/inbox/overview/i/${props.item.data.id}?action=${targetEvent}`);
                            setTimeout(() => {
                                inboxactionMessageareaStore.events = finalEventTracker[targetEvent];
                            },1000);
                        } else{
                            inboxactionMessageareaStore.events = finalEventTracker[targetEvent];
                        }
                    } else {
                        addNotification(trans("Aan het laden") + "...", 3500);
                    }
                    finished();
                });
            });
        };
        const handleRestore = () => {
            return new Promise(finished => {
                if (props.item) {
                    inboxStore.selected = [props.item.data.id];
                }

                // Store curren list so in any case our data is set for checks
                const backupItems = inboxStore.current?.data ? [inboxStore.current] : JSON.parse(JSON.stringify(inboxStore.items));
                // Set loader
                inboxactionStore.triggered = true;
                inboxactionStore.pause_filters = true;

                // Loop through our ids and trigger events
                const patchPromises = [];

                if (!inboxStore.selected.length) {
                    // No items selected
                    addNotification(trans("Selecteer eerst een item") + "...", 3500);
                    inboxactionStore.triggered = false;
                    inboxactionStore.pause_filters = false;
                    return;
                }

                inboxStore.selected.forEach(id => {
                    // Find the item
                    const item = resolveItem(backupItems, id) ? resolveItem(backupItems, id) : resolveItem([inboxStore.current], id);
                    if (!item) {
                        console.error("Item not found in inboxStore.items", id);
                        return;
                    }
                    patchPromises.push(new Promise(resolve => {
                        patchInbox(id, {state: "Online"}).then(result => {
                            inboxStore.items = inboxStore.items.filter(i => `${i.data.id}` !== `${id}`);
                            resolve(result);
                        });
                    }));
                });

                Promise.all(patchPromises).then(result => {
                    inboxactionStore.triggered = false;
                    clearInboxCache(routeData.value);
                    getInbox(routeData.value, [], false).then(() => {
                        setTimeout(() => {
                            inboxactionStore.pause_filters = false;
                        }, 500);
                    });
                    addNotification(trans("Aan het laden") + "...", 3500);
                    routeData.action = "overview";
                    gotoOverview();
                    finished();
                });
            });
        };

        const gotoOverview = () => {
            router.push({
                path: `/inbox/${routeData.value.action}`,
                query: {
                    page: routeData.value.page
                }
            });
            setTimeout(() => {
                // Slight timeout, then reset
                inboxStore.current = null;
                inboxStore.selected = [];
            }, 250);
        };

        const keydownHandling = (e) => {
            // Check if the target is an input or textarea
            const target = e.target;
            const isInputOrTextarea = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA';

            // Check if the pressed key is Backspace
            if (!isInputOrTextarea && !target.classList.contains("ck")) {
                if (e.key === "Backspace") {
                    e.preventDefault();

                    // if history back is the same url
                    if (window.history.length === 1) {
                        gotoOverview();
                        clearNotifications();
                    } else {
                        history.back();
                    }

                } else if (e.key === "Delete") {
                    e.preventDefault();
                    if (inboxStore.selected || routeData.value.item_id) {
                        deleteAction.value && handleClick(deleteAction.value).then(() => {
                            clearNotifications();
                        });
                    }
                }
            }
        };


        onMounted(() => {
            setTimeout(() => {
                // Slight delay to make inbox itself load at first
                // Pass the route data to keep the possibility to make route specific calls
                getInboxactions(routeData.value, []);
            }, 500);
            document.addEventListener('keydown', keydownHandling);
        });


        onUnmounted(() => {
            document.removeEventListener('keydown', keydownHandling);
        });

        const showRestore = computed(() => {
            if (routeData.value.action === 'trash') {
                return true;
            }
            if (inboxStore.current?.data?.state === 'Offline') {
                return true;
            }
            return false;
        });
        const showOptions = computed(() => {
            return !routeData.value.item_id;
        });



        const popupOpenData = reactive({
            options: false
        });

        const isDropdownOpen = (key = "options") => {
            return popupOpenData[key] ?? false;
        };
        const hideDropdown = (key = "options") => {
            popupOpenData[key] = false;
        };
        const toggleDropdown = (key = "options") => {
            popupOpenData[key] = !popupOpenData[key];
        };


        const handleMarkRead = () => {
            if (props.item) {
                inboxStore.selected = [props.item.data.id];
            }

            const tmpSelection = JSON.parse(JSON.stringify(inboxStore.selected));
            if (!tmpSelection.length) {
                addNotification(trans("Selecteer eerst een item") + "...", 3500);
                return;
            }
            addNotification(trans("Aan het verwerken") + "...", 3500);
            const patchPromises = [];
            tmpSelection.forEach(id => {
                const backupItems = inboxStore.current?.data ? [inboxStore.current] : JSON.parse(JSON.stringify(inboxStore.items));
                const item = resolveItem(backupItems, id);
                if (!item) return;

                const tmpFunction = () => {
                    return new Promise(resolve => {
                        handleRead(item).then(() => {
                            inboxStore.selected = inboxStore.selected.filter(i => `${i}` !== `${id}`);
                            resolve();
                        });
                    });
                };
                patchPromises.push(tmpFunction);
            });
            Promise.all(patchPromises.map(func => func())).then(result => {
                updateAllCount();
            });
            hideDropdown("options");
        };
        const handleMarkUnread = () => {
            if (props.item) {
                inboxStore.selected = [props.item.data.id];
            }

            const tmpSelection = JSON.parse(JSON.stringify(inboxStore.selected));
            if (!tmpSelection.length) {
                addNotification(trans("Selecteer eerst een item") + "...", 3500);
                return;
            }
            addNotification(trans("Aan het verwerken") + "...", 3500);
            const patchPromises = [];
            tmpSelection.forEach(id => {
                const backupItems = inboxStore.current?.data ? [inboxStore.current] : JSON.parse(JSON.stringify(inboxStore.items));
                const item = resolveItem(backupItems, id);
                if (!item) return;

                const tmpFunction = () => {
                    return new Promise(resolve => {
                        handleUnread(item).then(() => {
                            inboxStore.selected = inboxStore.selected.filter(i => `${i}` !== `${id}`);
                            resolve();
                        });

                    });
                };
                patchPromises.push(tmpFunction);
            });
            Promise.all(patchPromises.map(func => func())).then(result => {
                updateAllCount();
            });
            hideDropdown("options");
        };


        const handleAway = (e) => {
            hideDropdown('options');
        };


        const linkcardFields = computed(() => {
            const fields = [];
            linkcardData.event.forEach(item => {
                const options_json = {
                    filters: [
                        {
                            t: "FieldFilter",
                            c: "cardtype_id",
                            v: item.linkcard_cardtype,
                            o: "="
                        }
                    ]
                };
                fields.push({
                    "name": item.id,
                    "type": "StudioIbizz\\Workflowcard\\Elements\\CardField",
                    "label": item.title,
                    "options_json": JSON.stringify(options_json),
                    "tooltip_information": null,
                    "auto_fill": "N",
                    "extra": {
                        "colclass": "span12"
                    }
                });
            });

            return fields;
        });

        const handleLinkcardForm = (target) => {
            return new Promise((resolve, reject) => {
                const form = target.querySelector("form");
                if (!form) {
                    addNotification(trans("Er lijkt iets mis te gaan, probeer het later nog eens") + "...", 3500);
                    return reject();
                }
                const formData = new FormData(form);
                const formKeys = Array.from(formData.keys());
                linkcardData.values = {};
                formKeys.forEach(id => {
                    linkcardData.values[`${id}`] = formData.get(id);
                });
                if (!formKeys.length) {
                    addNotification(trans("Uw actie is geannuleerd"), 3500);
                }
                return resolve();
            });
        };

        const primaryLimit = 3;
        const primary = (result) => {
            return computed(() => {
                if(result.length <= primaryLimit) {
                    return result;
                }
                return result.filter(a => a?.primary === "Y");
            }).value;
        };
        const secundary = (result) => {
            return computed(() => {
                if (result.length <= primaryLimit) {
                    return [];
                }
                return result.filter(a => a?.primary !== "Y");
            }).value;
        };

        return {
            trans,

            inboxStore,
            inboxactionStore,
            routeData,

            items,

            iconName,

            handleClick,
            handleRestore,

            showRestore,
            showOptions,

            popupConfirmRef,
            popupLinkcardRef,

            popupOpenData,
            isDropdownOpen,
            hideDropdown,
            toggleDropdown,

            handleMarkRead,
            handleMarkUnread,

            handleAway,

            linkcardFields,
            handleLinkcardForm,

            primary,
            secundary
        }
    }
});

</script>
